module.exports = {"data":{"contentfulSection":{"content":{"childMarkdownRemark":{"html":"<h1>Portfolio on the way...</h1>\n<p>Someday, someday I'll get to this.</p>"}}}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/portfolio.json
// module id = 384
// module chunks = 192094587461937